import axios from 'axios';
import { AUTH_USER, AUTH_ERROR } from './types';

export const signup = (formProps, callback) => async dispatch => {
  try {
    const response = await axios.post('http://localhost:5000/api/register', formProps)
    dispatch({
      type: AUTH_USER,
      payload: response.data.token
    });
    localStorage.setItem('token', response.data.token);
    callback();
  } catch (e) {
    dispatch({
      type: AUTH_ERROR,
      payload: 'Some thing went wrong'
    });
  }
};

export const signin = (formProps, callback) => async dispatch => {
  try {
    formProps = {
      si_userName: formProps.username,
      password: formProps.password
    }
    const response = await axios.post('/cloud/loginview/', formProps)
    // alert(response.status)
    // console.log('🔐 Login API Response:', response); // 👈 Console log here

    dispatch({
      type: AUTH_USER,
      payload: response.data.token
    });
    //console.log(response.data)
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user_type', response.data.user_type); //(If user type 1 then it is Main admin and if it is 2 then it is User)


    let cookie = function () {
      let c_name = 'csrftoken';
      if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          var c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
            c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
          }
        }
      }
      return "";
    }


    // console.log(cookie())
    localStorage.setItem("csrftoken", cookie())
    callback('successlogin')
  } catch (e) {
    
    dispatch({
      type: AUTH_ERROR,
      payload: e.response.message
    });
    
    if (e.status === 400){
callback('inactiveUser')
    }else{
    
callback('invalidLogin')
    }
    
  }
};



export const setPassword = (formProps, callback) => async dispatch => {
  // console.log(formProps.browserDetails);
  try {
    formProps = {
      user_password: formProps.confirmpassword,
      url: window.location.pathname.slice(-16),
      browserDetails: {
        ...formProps.browserDetails
      }

    }
    const response = await axios.post('/cloud/setPasswordApi/', formProps)
    dispatch({
      type: AUTH_USER,
      payload: response.data.token
    });
    // console.log(response.data)
    localStorage.setItem('token', response.data.token);
    // localStorage.setItem('user_type', response.data.user_type); //(If user type 1 then it is Main admin and if it is 2 then it is User)


    let cookie = function () {
      let c_name = 'csrftoken';
      if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          var c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
            c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
          }
        }
      }
      return "";
    }


    // console.log(cookie())
    localStorage.setItem("csrftoken", cookie())
    callback('successlogin')
  } catch (e) {
    dispatch({
      type: AUTH_ERROR,
      payload: 'Invalid Credentials'
    });
    callback('invalidLogin')
  }
};




export const signout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('csrftoken');
  return {
    type: AUTH_USER,
    payload: ''
  }
}
